import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import Typography from '@material-ui/core/Typography';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Box, CircularProgress } from '@material-ui/core';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import SidebarButtons from '../../../@jumbo/components/AppLayout/partials/SideBar/SIdebarButtons';
import Divider from '@material-ui/core/Divider';
import ToggleAnalyticsCard from './ToggleAnalyticsCard';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { TextField } from '@material-ui/core';
import moment from 'moment';
import CmtButtons from '../../../@coremat/CmtButtons';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import PanelRevenue2 from './PanelRevenue2';
import PanelGeneral from './PanelGeneral';

import { getMyDate, getMyDate1 } from '../../../@jumbo/utils/commonHelper';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.cockpit'} />, isActive: true },
];

const today = new Date();
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const currentMonth = monthNames[today.getMonth()];
const pastMonth = monthNames[today.getMonth() - 1];

export const intranet = {
  monthlyTopChart: {
    title: 'Nights',
    hoverButton: {
      text: 'last 30 days',
      color: '#5D9405',
      hoverText: 'before',
      hoverColor: '#fff',
    },
    analyticData: {
      amount: '?',
      label: 'Total',
      percentage: '?%',
      onHover: {
        amount: '?',
        percentage: '?%',
      },
    },
    primaryColor: {
      solid: '#ADDC4C',
      light: '#D7F5B1',
    },
    secondaryColor: {
      solid: '#C8372D',
      light: '#FADEE3',
    },
    chartData: {
      current: [
        { label: 1 + ', ' + currentMonth, value: 100 },
        { label: 2 + ', ' + currentMonth, value: 120 },
        { label: 3 + ', ' + currentMonth, value: 130 },
        { label: 4 + ', ' + currentMonth, value: 120 },
        { label: 5 + ', ' + currentMonth, value: 110 },
        { label: 6 + ', ' + currentMonth, value: 105 },
        { label: 7 + ', ' + currentMonth, value: 110 },
        { label: 8 + ', ' + currentMonth, value: 120 },
        { label: 9 + ', ' + currentMonth, value: 130 },
        { label: 10 + ', ' + currentMonth, value: 140 },
        { label: 11 + ', ' + currentMonth, value: 145 },
        { label: 12 + ', ' + currentMonth, value: 140 },
        { label: 13 + ', ' + currentMonth, value: 130 },
        { label: 14 + ', ' + currentMonth, value: 125 },
      ],
      past: [
        { label: 1 + ', ' + pastMonth, value: 100 },
        { label: 2 + ', ' + pastMonth, value: 120 },
        { label: 3 + ', ' + pastMonth, value: 130 },
        { label: 4 + ', ' + pastMonth, value: 120 },
        { label: 5 + ', ' + pastMonth, value: 110 },
        { label: 6 + ', ' + pastMonth, value: 105 },
        { label: 7 + ', ' + pastMonth, value: 110 },
        { label: 8 + ', ' + pastMonth, value: 100 },
        { label: 9 + ', ' + pastMonth, value: 90 },
        { label: 10 + ', ' + pastMonth, value: 95 },
        { label: 11 + ', ' + pastMonth, value: 80 },
        { label: 12 + ', ' + pastMonth, value: 60 },
        { label: 13 + ', ' + pastMonth, value: 65 },
        { label: 14 + ', ' + pastMonth, value: 50 },
      ],
    },
  },
};

const useStyles = theme => ({
  card: {
    overflow: 'unset',
    marginBottom: theme.typography.pxToRem(32),
  },
  hotelSelect: {
    width: '100%',
    marginBottom: theme.typography.pxToRem(8),
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  cardContentInner: {
    position: 'relative',
    paddingBottom: 0,
  },

  boxClass: {
    paddingTop: theme.spacing(5),
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  guestPrice: {
    minWidth: 200,
  },
  currency: {
    minWidth: 200,
    marginLeft: 10,
  },
});

class Cockpit extends React.Component {
  constructor(props) {
    super(props);

    const enddate1 = moment();
    const startdate1 = moment().add(-6, 'day');

    const enddate2 = moment().add(-7, 'day');
    const startdate2 = moment().add(-13, 'day');

    const startdate = moment();
    const enddate = moment().add(14, 'day');
    var hotels = this.props.auth.authUser.hotels;
    this.state = {
      valueStay: null,
      valueDeparute: null,
      valueBooking: null,
      valueStatus: null,
      valueArrival: null,
      panel2: '',
      panel3: '',
      panel4: '',
      visibledays: [],
      hotelId: hotels[0].id,
      dateStart1: startdate1,
      dateEnd1: enddate1,

      dateStart: startdate,
      dateEnd: enddate,
      availableRooms: [],
    };
    //this.setState({ panel1: mydata });
    this.PrepareData = this.PrepareData.bind(this);
    this.PrepareData2 = this.PrepareData2.bind(this);
    this.PrepareData2(startdate1, enddate1, startdate2, enddate2);
    this.PrepareData3 = this.PrepareData3.bind(this);
    this.handleCustomChange = this.handleCustomChange.bind(this);
  }

  PrepareData2(fromDate, toDate, previusStart, previusEnd) {
    var fromDateISO = getMyDate(fromDate);
    var toDateISO = getMyDate(toDate);
    var action = '';
    const token = localStorage.getItem('token');
    var hotelCode = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotelId)[0].hotelCode;
    const senddata = {
      Action: 'get_dashboard_panels',
      token: token,
      Version: 1,
      Data: {
        HotelId: this.state.hotelId,
        HotelCode: hotelCode,
        Type: 'revenue|income|adr|revpar',
        PeriodStart: fromDateISO,
        PeriodEnd: toDateISO,
        //       PreviusStart: getMyDate(previusStart),
        //        PreviusEnd: getMyDate(previusEnd),
      },
    };
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data) {
        console.log(res.data.Data);
        console.log(res.data.Data[0]);
        //if (res.data.Data) {
        //console.log(res.data.Data[0].arrival[0]);
        this.setState({ valueRevenue: res.data.Data.revenue[0] });
        this.setState({ valueIncome: res.data.Data.income[0] });
        this.setState({ valueAdr: res.data.Data.adr[0] });
        this.setState({ valueRevpar: res.data.Data.revpar[0] });
      }
    });
  }

  PrepareData3(day) {
    var action = '';
    const token = localStorage.getItem('token');
    var hotelCode = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotelId)[0].hotelCode;
    const senddata = {
      Action: 'get_dashboard_panels',
      token: token,
      Version: 1,
      Data: {
        HotelId: this.state.hotelId,
        HotelCode: hotelCode,
        Type: 'status',
        Period: day,
      },
    };
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;
    //return;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data) {
        console.log(res.data.Data);
        console.log(res.data.Data[0]);
        if (res.data.Data)
          if (res.data.Data[0]) {
            this.setState({ valueStatus: res.data.Data[0] });
            //console.log(res.data.Data[0].arrival[0]);
            /*
        this.setState({ valueBooking: res.data.Data.booking[0] });
        this.setState({ valueDeparture: res.data.Data.departure[0] });
        this.setState({ valueStay: res.data.Data.stay[0] });*/
          }
      }
    });
  }

  PrepareData(day) {
    var action = '';
    const token = localStorage.getItem('token');
    var hotelCode = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotelId)[0].hotelCode;
    const senddata = {
      Action: 'get_dashboard_panels',
      Version: 1,
      token: token,
      Data: {
        HotelId: this.state.hotelId,
        HotelCode: hotelCode,

        Type: 'arrival|departure|stay|booking',
        Period: day,
      },
    };
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;
    //return;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data) {
        console.log(res.data.Data);
        console.log(res.data.Data[0]);
        //if (res.data.Data) {
        //console.log(res.data.Data[0].arrival[0]);
        this.setState({ valueArrival: res.data.Data.arrival[0] });
        this.setState({ valueBooking: res.data.Data.booking[0] });
        this.setState({ valueDeparture: res.data.Data.departure[0] });
        this.setState({ valueStay: res.data.Data.stay[0] });
        //}
      }
    });
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    setCurrentPage(intl.formatMessage({ id: 'pages.cockpit' }));
    this.PrepareData('today');
    this.PrepareData3('today');
    // this.setState({ panel2: mydata });
    // this.setState({ panel3: mydata });
    // this.setState({ panel4: mydata });
  }

  handleCustomChange(event, owner) {
    this.setState({ [owner]: event.target.value }, () => {
      if (owner == 'hotelId') {
        //        var curStart = this.state.dateStart;
        this.PrepareData('today');
        this.PrepareData3('today');
        const enddate1 = moment();
        const startdate1 = moment().add(-6, 'day');

        const enddate2 = moment().add(-7, 'day');
        const startdate2 = moment().add(-13, 'day');
        this.PrepareData2(startdate1, enddate1, startdate2, enddate2);
        //this.createDays(curStart.format('YYYY-MM-DD'));
      }
    });
  }

  render() {
    const { classes } = this.props;
    var hotels = this.props.auth.authUser.hotels;
    var roomtypes = this.props.auth.authUser.roomtypes;
    return (
      <PageContainer>
        {hotels.length > 1 && (
          <FormControl variant="filled" className={classes.hotelSelect}>
            <InputLabel id="hotel-label">Hotel</InputLabel>
            <Select
              labelId="hotel-label"
              id="hotelid"
              fullWidth
              className={classes.hotelSelect}
              name="hotelid"
              value={this.state.hotelId}
              onChange={event => this.handleCustomChange(event, 'hotelId')}>
              {hotels.map((t, idx) => (
                <MenuItem value={t.id}>{t.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Box>
          <GridContainer>
            <Grid item xs={3} sm={3} xl={3}>
              <PanelGeneral mode="arrival" color="#00CC6A" data={this.state.valueArrival} />
            </Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <PanelGeneral mode="departure" color="#E81123" data={this.state.valueDeparture} />
            </Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <PanelGeneral mode="stay" color="#F7630C" data={this.state.valueStay} />
            </Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <PanelGeneral mode="bookings" color="#0078D7" data={this.state.valueBooking} />
            </Grid>
          </GridContainer>
        </Box>
        <Box className={classes.boxClass}>
          <GridContainer>
            <Grid item xs={6} sm={6} xl={3}>
              <PanelRevenue2 mode="revenue" data={this.state.valueRevenue} title={<IntlMessages id="cockpit.revenue" />} />
            </Grid>
            <Grid item xs={6} sm={6} xl={3}>
              <PanelRevenue2 mode="income" data={this.state.valueIncome} title={<IntlMessages id="cockpit.income" />} />
            </Grid>
            <Grid item xs={6} sm={6} xl={3}>
              <PanelRevenue2 mode="adr" data={this.state.valueAdr} title={<IntlMessages id="cockpit.adr" />} />
            </Grid>
            <Grid item xs={6} sm={6} xl={3}>
              <PanelRevenue2 mode="revpar" data={this.state.valueRevpar} title={<IntlMessages id="cockpit.revpar" />} />
            </Grid>
          </GridContainer>
        </Box>
        <Box className={classes.boxClass}>
          <CmtCard className={classes.card}>
            <CmtCardContent className={classes.cardContent}>
              <GridContainer>
                <Grid item xs={6} sm={6} xl={3}>
                  <Typography>
                    <IntlMessages id="cockpit.accommodation" />
                  </Typography>
                  <GridContainer pt={6}>
                    <Grid item xs={6} sm={6} xl={3}>
                      <Typography>
                        <IntlMessages id="cockpit.occupiedRooms" />
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={3}>
                      <Typography>{this.state.valueStatus != null && this.state.valueStatus.Value1}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={3}>
                      <Typography>
                        <IntlMessages id="cockpit.freeRooms" />
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={3}>
                      <Typography>{this.state.valueStatus != null && this.state.valueStatus.Value2}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={3}>
                      <Typography>
                        <IntlMessages id="cockpit.outOfOrder" />
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={3}>
                      <Typography>{this.state.valueStatus != null && this.state.valueStatus.Value3}</Typography>
                    </Grid>
                  </GridContainer>
                </Grid>
                <Grid item xs={6} sm={6} xl={3}>
                  <Typography style={{ textAlign: 'center' }}>
                    <IntlMessages id="cockpit.occupancy" />
                  </Typography>
                  <Box position="relative" justifyContent="center" display="block">
                    <CircularProgress
                      className={classes.cirProRoot}
                      variant="static"
                      color="secondary"
                      size={120}
                      value={this.state.valueStatus != null ? this.state.valueStatus.Value4 : 0}
                      thickness={6}
                      style={{ position: 'absolute', left: '50%', transform: 'translate(-50%, 0)' }}
                    />
                    <Typography
                      variant="caption"
                      component="div"
                      color="textSecondary"
                      style={{ position: 'absolute', left: '50%', transform: 'translate(-50%, 50%)', bottom: '-75px' }}>
                      {this.state.valueStatus != null ? this.state.valueStatus.Value4 : 0}%
                    </Typography>
                  </Box>
                </Grid>
              </GridContainer>
            </CmtCardContent>
          </CmtCard>
        </Box>
      </PageContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

Cockpit.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(Cockpit)));
